import { Component, OnInit } from '@angular/core';
import {
  concatMap,
  finalize,
  map,
  mergeAll,
  takeUntil,
  tap,
} from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  CustomResult,
  DownloadAllUserDocumentsDto,
  GetEnumValuesDto,
  UploadUserDocumentsCommand,
  UserDocuments,
  UserState,
} from '../../../../core/api/models';
import { UsersService } from '../../../../core/api/services';
import { BaseFormPageComponent } from '../../../../pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { OrganizationsAuthenticationFormComponent } from "../../organizations/organizations-authentication-form/organizations-authentication-form.component";


@Component({
    selector: 'app-user-authentication-form',
    templateUrl: './user-authentication-form.component.html',
    styleUrls: ['./user-authentication-form.component.scss'],
    imports: [BaseFormModule, OrganizationsAuthenticationFormComponent]
})
export class UserAuthenticationFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  authenticateOrganization = false;
  authenticateType = 'user';
  updateModel: UploadUserDocumentsCommand = {};
  get UserState() {
    return UserState;
  }
  DocumentStatusEnumValues: GetEnumValuesDto[] = [];
  DocumentationTypeEnumValues: GetEnumValuesDto[] = [];
  allowedFiles = '.jpeg,.jpg,.png,.pdf';
  blobs: any[] = [];
  model: DownloadAllUserDocumentsDto[] = [];
  documentLoading: boolean = false;
  //#endregion

  constructor(protected currentService: UsersService) {
    super();
    this.formPageConfig.vocabs =
      'pages.users.userInfo.userAuthentication.form.';
    this.updateModel.items = [];
  }

  //#region init methods

  ngOnInit() {
    super.ngOnInit();
    this.getEnumsValues();
    this.pageConfig.showRefreshBtn = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('UserDocuments')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DocumentationTypeEnumValues = values));
    this.getEnumValuesApi('DocumentStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DocumentStatusEnumValues = values));
  }

  initForm() {}

  initModel() {
    this.downloadDocumentsApi();
  }

  //#endregion

  //#region Api

  downloadDocumentsApi() {
    this.unSubs();
    this.documentLoading = true;
    this.currentService
      .usersDownloadAllUserDocuments({
        UserId: this.currentUserInfo?.userId,
      })
      .pipe(
        map((res) => res.data),
        tap((data) => {
          this.createDocumentationInfoModel(data);
        }),
        mergeAll(),
        concatMap((item) => {
          if (item?.image)
            return this.currentService
              .usersUserDocumentLink({
                Input: item.image,
              })
              .pipe(
                map((blob) => ({
                  documentType: item.userDocument,
                  blob: blob,
                }))
              );
        }),
        finalize(() => (this.documentLoading = false))
      )
      .subscribe((res) => {
        this.blobs.push(res);
      });
  }

  //Create
  baseCreateApi(model: UploadUserDocumentsCommand) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .usersUploadUserDocuments({ body: this.updateModel })
      .pipe(this.basePipeOperators())
      .subscribe(
        (result: CustomResult) => {
          this.apiNotificationService.notifyMessage({ result });
          if (result.isSucceed) {
            this.formPageConfig.isEditMode = false;
            this.onSuccess();
            if (
              this.currentUserInfo.state == UserState.NotAuthenticatedUser &&
              !this.currentUserInfo?.isRealPerson &&
              this.currentUserInfo?.isAdminOrganization
            ) {
              this.authenticateOrganization = true;
            }
          }
        },
        (error) => ConsoleService.error('error', error),
        () => (this.loading = false)
      );
  }

  //#endregion

  //#region model operations
  //get blob file current item

  getUploadedItems(items) {
    try {
      this.updateModel.items.push(items);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getBlob(documentType: number): Blob {
    try {
      const blob = this.blobs.find((blob) => {
        return blob.documentType == documentType;
      });
      if (blob) {
        return blob.blob;
      } else return null;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //ایجاد آرایه ی مدل به تعداد همه ی مدارک
  createDocumentationInfoModel(items) {
    try {
      const values = Object.values(UserDocuments);
      let document: any[] = values.slice(values.length / 2);
      //creates an array of Model with enum length
      document.forEach((x) => {
        let documentType = items.find((b) => b.userDocument == x);
        if (documentType) {
          this.model.push(documentType);
        } else {
          let model: DownloadAllUserDocumentsDto = {};
          model.description = '';
          model.image = '';
          model.status = 1;
          model.userDocument = x;
          this.model.push(model);
        }
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //#endregion

  nextStep() {
    this.authenticateOrganization = true;
  }

  getFormResponse(event) {
    this.unSubs();
    if (!event) this.authenticateOrganization = false;
  }

  onSubmit() {
    if (this.loading) return;
    try {
      if (this.loading) return;
      this.baseCreateApi(this.updateModel);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
